export default "__VITE_ASSET__DzVPxa9n__"